import { LabelValue } from '../../types/common';

export const selectClientPortalConfigurations = (state: {
  ticketTemplates: { clientPortalConfigurations: LabelValue[] };
}): LabelValue[] => state.ticketTemplates.clientPortalConfigurations;
export const selectClientPortalCompanies = (state: {
  ticketTemplates: { clientPortalCompanies: LabelValue[] };
}): LabelValue[] => state.ticketTemplates.clientPortalCompanies;

export default {};
